import React from 'react';
import { connect } from 'react-redux';
import {
  salesTypePageRequest,
  cancelDelete,
  cancelActivated,
  deleteSalesType,
  activatedSalesType,
  showSalesTypeDeletableModal,
} from 'actions/library/salesType';
import NoDataAndLoading from 'components/NoDataAndLoading';
import ConfirmModal from 'components/ConfirmModal';
import LibraryActivateModalSalesType from 'components/LibraryActivateModalSalesType';
import { askConfirmAction } from 'actions/confirm-action';
import { isDirty, getFormValues } from 'redux-form';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import * as clevertapLibrarySalesType from 'clevertap/library/salesType';
import SaveToAllOutletsModal from './SaveToAllOutletsModal';
import LibraryDeleteModal from './LibraryDeleteModal';
import SalesTypeDetail from './SalesTypeDetail';
import List from './List';
import ActionBar from './ActionBar';
import styles from './SalesType.css';

class SalesType extends React.Component {
  render() {
    const {
      salesTypeDetail,
      isSubmittingForm,
      showDeleteModal,
      showActivatedModal,
      deletedSalesType,
      activatedSalesType,
      openRightColumn,
      showLoadingSpinnerPage,
      salesType,
      showSaveToAllOutletsModal,
      showCheckDeletableModal,
      checkDeletableModalType,
    } = this.props;
    const salesTypeName = deletedSalesType ? deletedSalesType.name : '';
    const textModalTitle =
      salesTypeDetail && salesTypeDetail.active_state === true
        ? 'Deactivate Sales Type'
        : 'Reactivate Sales Type';

    const hideDeletableModalCancel = true;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={salesType.length === 0}
              title="No Data To Display"
              description={
                <div>
                  Learn more about{' '}
                  <a
                    className={styles['link-creating-sales-type']}
                    onClick={this._onClickKnowledgeProducTracking}
                    href="https://mokaposhelp.zendesk.com/hc/id/articles/900000454066-Cara-Membuat-Sales-Type"
                    target="_blank"
                  >
                    Create Sales Type
                  </a>
                </div>
              }
            />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <SalesTypeDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title="Sales Type"
          name={salesTypeName}
          onDelete={this._onDelete}
          isSubmittingForm={isSubmittingForm}
        />
        <LibraryActivateModalSalesType
          showActivatedModal={showActivatedModal}
          onHide={this._onHideModalActivated}
          title={textModalTitle}
          name={activatedSalesType}
          onActivated={this._onActivated}
          isActivate={salesTypeDetail}
        />
        <ConfirmActionModal />
        {showSaveToAllOutletsModal && <SaveToAllOutletsModal />}
        <ConfirmModal
          showModal={showCheckDeletableModal}
          title={`${checkDeletableModalType} Sales Type`}
          description={`You cannot ${
            checkDeletableModalType === 'Delete' ? 'delete' : 'deactivate'
          } this sales type because one or more items are still using it for Sales Type pricing.`}
          onConfirm={this._onHideSalesTypeDeletableModal}
          confirmTitle="OK"
          onHide={this._onHideSalesTypeDeletableModal}
          hideCancelButton={hideDeletableModalCancel}
          cancelTitle="No"
          baseColor="danger"
        />
      </PageWrapper>
    );
  }

  componentDidMount() {
    clevertapLibrarySalesType.salesTypeStart();
    this.props.dispatch(salesTypePageRequest());
    browserHistory.listenBefore(location => {
      // this is still hacky, don't copy paste this
      if (this.props.isDirtySalesType && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  _onDelete = () => {
    const {
      dispatch,
      salesType,
      outlets,
      deletedSalesType,
      currentOutletId,
    } = this.props;
    dispatch(
      deleteSalesType(
        outlets,
        currentOutletId,
        deletedSalesType.id,
        deletedSalesType.business_id,
        salesType
      )
    );
  };

  _onActivated = salesTypeDetail => {
    const { dispatch, salesType, outlets, currentOutletId } = this.props;
    dispatch(
      activatedSalesType(outlets, currentOutletId, salesTypeDetail, salesType)
    );
    // There are any delay when close modal
    // this code mean close modal after clicking save
    this._onHideModalActivated();
  };

  _onHideModal = () => {
    this.props.dispatch(cancelDelete());
  };

  _onHideModalActivated = () => {
    this.props.dispatch(cancelActivated());
  };

  _onHideSalesTypeDeletableModal = () => {
    this.props.dispatch(showSalesTypeDeletableModal(0, false, ''));
  };
}

function mapStateToProps(state) {
  const {
    salesType,
    outlets,
    isSubmittingForm,
    salesTypeDetail,
    showDeleteModal,
    showActivatedModal,
    deletedSalesType,
    activatedSalesType,
    openRightColumn,
    showSaveToAllOutletsModal,
    showCheckDeletableModal,
    checkDeletableModalType,
  } = state.library.salesType;
  const isDirtySalesType = isDirty('salesType')(state);
  const { nextAction } = state.confirmAction;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const currentOutletId = getFormValues('search')(state);
  return {
    salesType,
    salesTypeDetail,
    showDeleteModal,
    showActivatedModal,
    deletedSalesType,
    activatedSalesType,
    isDirtySalesType,
    nextAction,
    openRightColumn,
    showLoadingSpinnerPage,
    showSaveToAllOutletsModal,
    currentOutletId,
    outlets,
    isSubmittingForm,
    showCheckDeletableModal,
    checkDeletableModalType,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesType);
